export default "/fonts/vendor/katex/dist/KaTeX_AMS-Regular.ttf?853be92419a6c3766b9afe7a7c3e32fa";